<template>
  <div>
    <el-tree
      :data="treeData"
      :expand-on-click-node="false"
      :highlight-current="true"
      :load="load"
      :props="orgProps"
      @node-click="handleNodeClick"
      lazy
      node-key="projectId"
      ref="tree"
      v-loading="loading"
    />

    <div :style="style" aria-hidden="true" class="el-tooltip__popper is-dark"
         role="tooltip" style="transform-origin: center bottom;z-index: 2019"
         x-placement="bottom">{{tooltipText}}

        <span class="pointer mgl-10 txt-primary" @click="copy(tooltipText)">复制</span>
      <div class="popper__arrow"></div>
    </div>
  </div>
</template>

<script>
  import * as Types from "@/store/mutation-types";
  import _ from 'lodash'
  import $ from 'jquery'

  export default {
    props: ["value"],
    data() {
      return {
        treeData: [],
        loading: false,
        visible: false,
        position: {},
        tooltipText: "",
        orgProps: {
          label: function (data) {
            return `${data.name}[${data.id}]`
          },
          isLeaf: function (data) {
            return !data.children;
          }
        }
      };
    },

    computed: {
      style() {
        let display = this.visible ? 'block' : 'none';
        return {display, top: (this.position.top + 20) + "px", left: "10px"}
        // return {display, top: "-10px", left: "100px"}
      }
    },

    methods: {
      load({level, data}, resolve) {
        this.loading = true;

        if (level === 0) {
          this.$store
            .dispatch(Types.COMMON_PROJECT_RESOURCE_PROJECTS)
            .then(projects => {
              projects.forEach(item => {
                item.children = true;
                item.id = item.projectId;
              });
              resolve(projects);
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          this.$store
            .dispatch(Types.COMMON_PROJECT_RESOURCE_LIST, data.id)
            .then(resource => {
              resource.forEach(item => {
                item.id = item.resourceId;
                item.children = item.hasChildren;
              });
              resolve(resource);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      },
      handleNodeClick(data, node, elm) {
        this.$emit("active", data);
        this.$emit("input", data.id);
        this.show(elm, data)
      },
      show(elm, {id}) {
        if (!_.isObject(elm)) return

        this.position = $(elm.$el).position()
        this.visible = true
        this.tooltipText = id
      },
      copy(tooltipText) {
        console.log(tooltipText)
        this.copyFrom(tooltipText)
      },

      copyFrom(value) {
        // 数字没有 .length 不能执行selectText 需要转化成字符串
        const textString = value.toString();
        let input = document.querySelector("#copy-input");
        if (!input) {
          input = document.createElement("input");
          input.id = "copy-input";
          input.readOnly = "readOnly"; // 防止ios聚焦触发键盘事件
          input.style.position = "absolute";
          input.style.left = "-1000px";
          input.style.zIndex = "-1000";
          document.body.appendChild(input);
        }
        input.value = textString;

        this.selectText(input, 0, textString.length);
        if (document.execCommand("copy")) {
          document.execCommand("copy");
          this.$JBMessage.success("已复制到粘贴板");
        } else {
          this.$JBMessage.warning( "当前浏览器不支持");
        }
        document.body.removeChild(input);
      },
      // input自带的select()方法在苹果端无法进行选择，所以需要自己去写一个类似的方法
      // 选择文本。createTextRange(setSelectionRange)是input方法
      selectText(textbox, startIndex, stopIndex) {
        if (textbox.createTextRange) {
          //ie
          const range = textbox.createTextRange();
          range.collapse(true);
          range.moveStart("character", startIndex); //起始光标
          range.moveEnd("character", stopIndex - startIndex); //结束光标
          range.select(); //不兼容苹果
        } else {
          //firefox/chrome
          textbox.setSelectionRange(startIndex, stopIndex);
          textbox.focus();
        }
      }
    },


    mounted() {
    }
  };
</script>
